/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * building
 */
export interface StructureInspectionGrade { 
    /**
     * ID of the structure
     */
    structureId?: number;
    /**
     * year of Inspection
     */
    year?: number;
    /**
     * grade of inspection
     */
    value?: number;
}

